import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VOverlay,{staticClass:"align-center justify-center overlay",attrs:{"value":_vm.isShow,"z-index":"100"}},[_c(VProgressCircular,{attrs:{"color":"white","size":"80","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }